module.exports = __webpack_public_path__ + "img/pro_two_3.3a0d1b86.jpg";